import Instafeed from '../../vendor/instafeed';

const instafeeds = {};

const feedInit = (section_id, $feed) => {
  instafeeds[section_id] = new Instafeed({
    accessToken: $feed.data('accessToken'),
    get: 'user',
    userId: $feed.data('accessToken').split('.')[0],
    limit: $feed.data('limit'),
    imageResolution: 'standard-resolution',
    imageTemplate: $feed.data('template').split('@@').join('{{').split('%%').join('}}'),
    target: `Instafeed${section_id}`,
    onAfter: () => {
      // Animate items in
      const animation_time = 100;

      $('.Instapost').each((i, item) => {
        const $post = $(item);

        setTimeout(() => {
          $post.addClass('Animate--animated');
        }, i * animation_time);
      });

      if ($feed.data('type') === 'Mosaic') {
        // 2:1 width:height ration by default
        let size_ratio = 0.5;

        if ($(`#section${section_id}`).find('.InstagramMosaic--large').length > 0) {
          // 1:1 ratio for large mosaic
          size_ratio = 1;
        }

        $(window).resize(() => {
          $feed.closest('.InstagramMosaic').height($feed.width() * size_ratio);
        });

        $feed.closest('.InstagramMosaic').height($feed.width() * size_ratio);
      }
    },
  });

  instafeeds[section_id].run();
};

export { instafeeds, feedInit };
